import { Mail } from 'lucide-react';
import { useAuth } from '@workos-inc/authkit-react';
import { Switch } from '@/components/ui/switch';

export function EmailNotificationCard({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}) {
  const { user } = useAuth();

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-border bg-card p-4 shadow-sm sm:p-5">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted">
        <Mail className="h-5 w-5 text-foreground" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-medium text-foreground">Email</div>
        <div className="truncate text-sm text-muted-foreground">
          {user?.email ?? 'No email on file'}
        </div>
      </div>
      <Switch checked={enabled} onCheckedChange={onToggle} aria-label="Email" />
    </div>
  );
}
